import {Pipe, PipeTransform} from '@angular/core';
import {Column, TableService} from 'app/shared/service/table.service';

/**
 * Renvoie le champ d'un élément sous forme d'URL.
 */
@Pipe({name: 'elementFieldAsUrl'})
export class ElementFieldUrlPipe implements PipeTransform {

    constructor(public tableService: TableService) {
    }

    transform(element: any, column: Column): string {
        return this.tableService.getFieldValueAsUrl(element, column);
    }
}
